export default __webpack_public_path__ + "static/media/5 SECURITY VEHICLES.81c83659.png";